import React from 'react';

/**
 * TeacherCardSkeleton
 * Shimmer placeholder shown while the teacher list is loading.
 * Use in a grid column identical to TeacherCardGrid.
 */
export const TeacherCardSkeleton = () => {
  return (
    <div className="tp-card-grid">
      <span className="tp-skeleton tp-skeleton--avatar" />

      <div className="tp-card-grid__body">
        <span className="tp-skeleton tp-skeleton--text-lg" />
        <span className="tp-skeleton tp-skeleton--text-sm" />
        <span className="tp-skeleton tp-skeleton--text-sm" />
        <span className="tp-skeleton tp-skeleton--text-xs" />
        <span className="tp-skeleton tp-skeleton--btn" />
      </div>
    </div>
  );
};

/**
 * TeacherGridSkeletons
 * Renders `count` skeleton cards inside a 4-column grid row.
 */
export const TeacherGridSkeletons = ({ count = 8 }) => {
  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 g-4">
      {Array.from({ length: count }).map((_, i) => (
        <div className="col" key={i}>
          <TeacherCardSkeleton />
        </div>
      ))}
    </div>
  );
};
